import { KeycloakInitOptions } from 'keycloak-js';

export const _kcConfigs: KeycloakInitOptions = {
  checkLoginIframe: true,
  onLoad: 'check-sso',
  silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
  pkceMethod: 'S256',
};
